module.exports = __webpack_public_path__ + "static/media/ope_riikka_832x832.d9bc0810.jpg";